import React from 'react';

const IndexItemTitle = (props) => {
    const { title, subTitle, height, bc } = props;
    return(
        <div className="title-wrapper" style={{height: height}}>
            <div className="title-line"></div>
            <div className="title-content" style={bc ? {backgroundColor: bc}:null}>{title}</div>
            <div className="title-sub">{subTitle}</div>
        </div>
    )
}

export default IndexItemTitle;